import React from 'react'
import Icons from '~/Common-Objects/UI/Icons/index';
import Indicator from '~/Common-Objects/UI/Indicator/index';
import Paper from '~/Common-Objects/UI/Paper/Paper';
import i18n from '~/i18n';
import { useSelector } from 'react-redux';
import FormatNumberFuncs from '../../../../Classes/numberFormatFunctions';


export default function SubscribersClicked({ clicks, edit = () => { } }) {
    const siteMaster = useSelector(state => state.siteMaster)
    let increaseHolder = <Indicator className="indicator-grey">0.00%</Indicator>;
    if ((clicks.increase || clicks.decrease) !== Infinity) {
        if (clicks.increase) increaseHolder = <Indicator leftIcon={<Icons icon="arrowUp" color={siteMaster.colours["$status-green"]} />} className=" indicator-green">{FormatNumberFuncs.formatNumber(clicks.increase, 2)}%</Indicator>
        if (clicks.decrease) increaseHolder = <Indicator leftIcon={<Icons icon="arrowDown" color={siteMaster.colours["$status-red"]} />} className="indicator-red">{FormatNumberFuncs.formatNumber(clicks.decrease, 2)}%</Indicator>
    }
    return <Paper className="m-mar-b0" iconRight={<Icons icon="pencil" color="grey" />} iconRightClick={edit}>

        <h4 className="mar-b5">{i18n.t('dashboard:welcomePage.subscriberClicks')}</h4>
        <div className="mar-b24">{i18n.t('dashboard:welcomePage.thisMonth')}</div>
        <div className="quickFlex">
            <h4 className="mar-r16 statistic">{FormatNumberFuncs.formatNumber(clicks.current)}</h4>
            {increaseHolder}
            <div style={{ height: "40px" }} />
        </div>


    </Paper >
}